<template>
  <div class="app-layout">
    <AppHeader />
    <main class="app-layout__main">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
// Layout par défaut — utilisé par toutes les pages publiques SSR / prerendered.
// AppHeader et AppFooter sont auto-importés par Nuxt depuis /components/.
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-layout__main {
  flex: 1;
  padding-top: var(--header-height);
}
</style>
